/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "aa41ca23bb5f32ddba1fa34639c6c9367c9f1e8c";
